export enum RecordType {
  CLINIC = 'clinic',
  TREATMENT = 'treatment',
  DOCTOR = 'doctor',
}

export interface APIBeforeAfterPhoto {
  aftermedia?: {
    url: string | null;
    name: string;
    width: number | undefined;
    height: number | undefined;
  } | null;
  beforemedia?: {
    url: string | null;
    name: string;
    width: number | undefined;
    height: number | undefined;
  } | null;
  beforeafterphoto?: {
    locale: string;
    description: string;
    omit_before_picture?: string | null;
    treatment: string | null;
  } | null;
}

export type BeforeAfterPhotosResponse = {
  mappedBaPhotos: APIBeforeAfterPhoto[];
  totalCount: number;
};

export type ClinicBeforeAfterPhoto = {
  locale: string;
  payload: {
    after_photo: string;
    before_photo: string;
    description: string;
    omit_before_picture: string;
    slug?: string;
  };
  treatment: string | null;
};

export type ClinicBeforeAfterMedia = {
  aftermedia: {
    payload: {
      url: string;
      name: string;
      width: number | undefined;
      height: number | undefined;
    };
  };
  beforemedia: {
    payload: {
      url: string;
      name: string;
      width: number | undefined;
      height: number | undefined;
    };
  };
  beforeafterphoto: ClinicBeforeAfterPhoto;
  slug?: string;
  treatment?: string;
};
